import React from "react";
import { useSettings } from "@/context/SettingsContext";

const WhatsAppFloat = () => {
  const { settings } = useSettings();
  if (!settings?.whatsapp_number) return null;
  const number = settings.whatsapp_number.replace(/[^\d]/g, "");
  const text = encodeURIComponent("¡Hola AQ Watches! Me gustaría conocer más sobre sus piezas personalizadas.");

  return (
    <a
      data-testid="whatsapp-float"
      href={`https://wa.me/${number}?text=${text}`}
      target="_blank"
      rel="noreferrer"
      aria-label="Chatear por WhatsApp"
      className="fixed bottom-6 right-6 z-40 bg-[var(--aq-success)] hover:bg-[var(--aq-success-hover)] text-white w-14 h-14 rounded-full flex items-center justify-center shadow-xl shadow-black/10 hover:scale-105 transition-transform"
    >
      <svg viewBox="0 0 32 32" width="26" height="26" fill="currentColor" aria-hidden="true">
        <path d="M19.11 17.32c-.27-.13-1.59-.79-1.84-.87-.25-.09-.43-.13-.61.14-.18.27-.7.87-.86 1.05-.16.18-.32.2-.59.07-.27-.14-1.14-.42-2.17-1.34-.8-.71-1.34-1.59-1.49-1.86-.16-.27-.02-.41.12-.55.13-.13.27-.34.41-.51.14-.17.18-.29.27-.48.09-.18.05-.34-.02-.48-.07-.13-.61-1.46-.83-2-.22-.53-.45-.45-.61-.46l-.52-.01c-.18 0-.48.07-.73.34-.25.27-.96.94-.96 2.29s.98 2.66 1.12 2.85c.14.18 1.94 2.97 4.71 4.16.66.28 1.18.45 1.58.58.67.21 1.27.18 1.75.11.53-.08 1.59-.65 1.81-1.27.22-.62.22-1.16.16-1.27-.07-.11-.25-.18-.52-.32z"/>
        <path d="M26.27 5.69A14.7 14.7 0 0 0 16 1.5c-8.1 0-14.69 6.59-14.69 14.7 0 2.59.68 5.12 1.97 7.34L1.5 30.5l7.18-1.74a14.66 14.66 0 0 0 7.32 1.96h.01c8.1 0 14.69-6.59 14.69-14.7 0-3.92-1.53-7.61-4.43-10.33zM16 28.05a12.13 12.13 0 0 1-6.18-1.69l-.44-.26-4.27 1.03 1.05-4.16-.29-.46a12.16 12.16 0 0 1-1.87-6.51c0-6.72 5.47-12.18 12.19-12.18A12.18 12.18 0 0 1 28.18 16c0 6.72-5.46 12.05-12.18 12.05z"/>
      </svg>
    </a>
  );
};

export default WhatsAppFloat;
